import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);

  const isActive = (path: string) => location.pathname === path;

  return (
    <header
      className={
        'fixed top-0 left-0 right-0 z-50 transition-all duration-300 ' +
        (isScrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent')
      }
    >
      <nav className="max-w-7xl mx-auto px-4 md:px-6" aria-label="主导航">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 flex-shrink-0">
            <h1 className="text-xl md:text-2xl font-heading text-primary-500 whitespace-nowrap">
              韩漫星球
            </h1>
          </Link>

          <div className="hidden md:flex items-center gap-6">
            <Link
              to="/"
              className={
                'text-sm font-medium transition-colors duration-200 whitespace-nowrap ' +
                (isActive('/') ? 'text-primary-500' : 'text-foreground-700 hover:text-primary-500')
              }
            >
              首页
            </Link>
            {categories.slice(0, 4).map(cat => (
              <Link
                key={cat.slug}
                to={'/category/' + cat.slug}
                className={
                  'text-sm font-medium transition-colors duration-200 whitespace-nowrap ' +
                  (isActive('/category/' + cat.slug) ? 'text-primary-500' : 'text-foreground-700 hover:text-primary-500')
                }
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className={
                'text-sm font-medium transition-colors duration-200 whitespace-nowrap ' +
                (isActive('/about') ? 'text-primary-500' : 'text-foreground-700 hover:text-primary-500')
              }
            >
              关于我们
            </Link>
          </div>

          <div className="hidden md:flex items-center gap-3">
            <div className="relative">
              <input
                type="text"
                placeholder="搜索漫画..."
                className="w-48 px-3 py-2 text-sm bg-background-100 border border-background-200 rounded-full text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-300 focus:ring-1 focus:ring-primary-200 transition-all duration-200"
              />
              <i className="ri-search-line absolute right-3 top-1/2 -translate-y-1/2 text-foreground-400 text-sm"></i>
            </div>
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-700"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            aria-label="切换菜单"
          >
            <i className={isMobileMenuOpen ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'}></i>
          </button>
        </div>

        {isMobileMenuOpen && (
          <div className="md:hidden bg-background-50 border-t border-background-200 py-4 animate-[fadeIn_200ms_ease-out]">
            <div className="flex flex-col gap-1 px-2">
              <Link
                to="/"
                className={
                  'px-3 py-2.5 rounded-lg text-sm font-medium transition-colors ' +
                  (isActive('/') ? 'bg-primary-100 text-primary-600' : 'text-foreground-700 hover:bg-background-100')
                }
              >
                首页
              </Link>
              {categories.map(cat => (
                <Link
                  key={cat.slug}
                  to={'/category/' + cat.slug}
                  className={
                    'px-3 py-2.5 rounded-lg text-sm font-medium transition-colors ' +
                    (isActive('/category/' + cat.slug) ? 'bg-primary-100 text-primary-600' : 'text-foreground-700 hover:bg-background-100')
                  }
                >
                  {cat.name}
                </Link>
              ))}
              <Link
                to="/about"
                className={
                  'px-3 py-2.5 rounded-lg text-sm font-medium transition-colors ' +
                  (isActive('/about') ? 'bg-primary-100 text-primary-600' : 'text-foreground-700 hover:bg-background-100')
                }
              >
                关于我们
              </Link>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}